export const PLATFORM_TYPE = {
  /* eslint no-useless-computed-key: "off" */
  [1]: '阿里云短信平台',
  [2]: '创蓝短信平台',
  [3]: '云浪无迹短信平台'
}

export const TEMPLATE_TYPE = {
  /* eslint no-useless-computed-key: "off" */
  [0]: '短信验证码',
  [1]: '普通通知',
  [2]: '推广短信'
}

export const TEMPLATE_STATUS = {
  /* eslint no-useless-computed-key: "off" */
  [0]: '审核中',
  [1]: '审核通过',
  [2]: '审核未通过',
  [4]: '失效'
}

/** 模板审核状态select */
export const templateStatusOptions = [
  {
    value: 0,
    label: '审核中'
  },
  {
    value: 1,
    label: '审核通过'
  },
  {
    value: 2,
    label: '审核未通过'
  }
]

/** 模板类型select */
export const templateTypeOptions = [
  {
    value: 0,
    label: '短信验证码'
  },
  {
    value: 1,
    label: '普通通知'
  },
  {
    value: 2,
    label: '推广短信'
  }
]

export const tableDataSchemas = [
  {
    prop: 'appName',
    label: '短信接入方名称',
    minWidth: 80
  },
  {
    prop: 'platform',
    label: '接入的短信平台',
    minWidth: 80
  },
  {
    prop: 'templateCode',
    label: '第三方平台模板编号',
    minWidth: 80
  },
  {
    prop: 'templateName',
    label: '第三方平台模板名称',
    minWidth: 80
  },

  { prop: 'templateType', label: '模板类型', minWidth: 80 },
  { prop: 'templateStatus', label: '审核状态', minWidth: 80 }
]

export const placeholderList = [
  {
    type: 'common',
    tip: '通用类标签',
    list: [
      {
        label: '患者姓名',
        desc: '患者姓名',
        value: 'name'
      },
      {
        label: '称呼',
        desc: '称呼，例如:先生、女士',
        value: 'call'
      },
      {
        label: '诊所名称',
        desc: '诊所名称，例如:一牙演示门诊',
        value: 'clinic'
      },
      {
        label: '诊所联系电话',
        desc: '诊所联系电话，例如: 400-085-0709',
        value: 'phone'
      }
    ]
  },
  {
    type: 'appoint',
    tip: '预约类标签',
    list: [
      {
        label: '预约医生',
        desc: '医生姓名，例如:李医生',
        value: 'doctor'
      },
      {
        label: '预约时间',
        desc: '预约时间，例如:2023-08-18 09:00',
        value: 'date'
      }
    ]
  },
  {
    type: 'member',
    tip: '会员卡类标签',
    list: [
      {
        label: '会员卡类型',
        desc: '会员卡类型，例如: 贵宾卡',
        value: 'card'
      },
      {
        label: '会员卡卡号',
        desc: '会员卡卡号，例如: VIP000001',
        value: 'cardNo'
      },
      {
        label: '会员卡到期日',
        desc: '会员卡到期日，例如:2023-12-31',
        value: 'deadline'
      },
      {
        label: '会员卡到期积分',
        desc: '会员卡到期积分，例如:23',
        value: 'points'
      },
      {
        label: '会员卡变动内容',
        desc: '会员卡变动内容，例如: 充值了1000元。',
        value: 'cardOper'
      }
    ]
  },
  {
    type: 'member',
    tip: '储值卡标签',
    list: [
      {
        label: '储值卡主卡人',
        desc: '储值卡主卡人',
        value: 'prepaid_opercount'
      },
      {
        label: '储值卡操作人',
        desc: '储值卡操作人',
        value: 'prepaid_opertor'
      },
      {
        label: '储值卡操作时间',
        desc: '储值卡操作时间',
        value: 'prepaid_opertime'
      },
      {
        label: '储值卡操作类型',
        desc: '储值卡操作类型',
        value: 'prepaid_opertype'
      },
      {
        label: '储值卡操作金额',
        desc: '储值卡操作金额',
        value: 'prepaid_operfee'
      },
      {
        label: '储值卡操作本金',
        desc: '储值卡操作本金',
        value: 'prepaid_opbalance'
      },
      {
        label: '储值卡操作赠金',
        desc: '储值卡操作赠金',
        value: 'prepaid_operbonus'
      },
      {
        label: '储值卡余额',
        desc: '储值卡余额',
        value: 'prepaid_total'
      },
      {
        label: '储值卡本金余额',
        desc: '储值卡本金余额',
        value: 'prepaid_balance'
      },
      {
        label: '储值卡赠金余额',
        desc: '储值卡赠金余额',
        value: 'prepaid_bonus'
      }
    ]
  }
]

const validateContent = (rule, value, callback) => {
  let result = []
  placeholderList.forEach((item) => {
    const valueList = item.list.reduce((prev, item) => {
      return [...prev, item.value]
    }, [])

    result = result.concat(valueList)
  })

  const pattern = /\${(.*?)}/g
  let match
  while ((match = pattern.exec(value)) !== null) {
    if (!result.includes(match[1])) {
      console.log(match[1])
      callback(new Error(`${match[1]}是非法字符`))
    }
  }

  // const regex = /(\${(.+)})+(\${(.+)})/g

  // const temp = regex.exec(value)
  // if (temp) {
  //   callback(new Error(`${temp[0]}是不规范的格式，短信模板内容中不支持组合变量`))
  // }
  callback()
}

const validateAli = (rule, value, callback) => {
  const regex = /(\${(.+)})+(\${(.+)})/g

  const temp = regex.exec(value)
  if (temp) {
    // callback(new Error(`${temp[0]}是不规范的格式，短信模板内容中不支持组合变量`))
    callback(new Error('不支持组合变量或变量相邻'))
  }
  callback()
}

// 基础设置 form
export const formSchemas = [
  {
    field: 'templateName',
    defaultValue: '',
    component: 'Input',
    label: '第三方平台模板名称',
    placeholder: '请输入第三方平台模板名称',
    rules: [
      {
        required: true,
        message: '第三方平台模板名称不能为空',
        trigger: ['blur']
      }
    ]
  },
  {
    field: 'templateContent',
    defaultValue: '',
    component: 'InputTextArea',
    label: '审核通过的模板内容格式',
    placeholder: '请输入审核通过的模板内容格式,示例：您正在申请手机注册,验证码为：$' + '{code}.......',
    rules: [
      {
        required: true,
        message: '审核通过的模板内容格式不能为空',
        trigger: ['blur']
      },
      {
        validator: validateContent,
        trigger: ['blur', 'change']
      },
      {
        validator: validateAli,
        trigger: ['blur', 'change']
      }
    ]
  },
  {
    field: 'platform',
    defaultValue: 1,
    component: 'Radio',
    label: '短信平台',
    radioArr: [
      {
        label: '阿里云平台',
        value: 1
      },
      {
        label: '创蓝短信平台',
        value: 2
      },
      {
        label: '云浪无迹短信平台',
        value: 3
      }
    ]
  },
  {
    field: 'templateType',
    defaultValue: 1,
    component: 'Radio',
    label: '模板类型',
    radioArr: [
      {
        label: '短信验证码',
        value: 0
      },
      {
        label: '普通通知',
        value: 1
      },
      {
        label: '推广短信',
        value: 2
      }
    ]
  },
  {
    field: 'remark',
    defaultValue: '',
    component: 'InputTextArea',
    label: '模板申请说明',
    placeholder: '请输入备注, 短信模板申请说明，是模板审核的参考信息之一。。',
    rules: [
      {
        required: true,
        message: '备注不能为空',
        trigger: ['blur']
      }
    ]
  }
]

// 基础设置 form
export const clFormSchemas = [
  {
    field: 'templateName',
    defaultValue: '',
    component: 'Input',
    label: '第三方平台模板名称',
    placeholder: '请输入第三方平台模板名称',
    rules: [
      {
        required: true,
        message: '第三方平台模板名称不能为空',
        trigger: ['blur']
      }
    ]
  },
  {
    field: 'templateContent',
    defaultValue: '',
    component: 'InputTextArea',
    label: '审核通过的模板内容格式',
    placeholder: '请输入审核通过的模板内容格式,示例：您正在申请手机注册,验证码为：$' + '{code}.......',
    rules: [
      {
        required: true,
        message: '审核通过的模板内容格式不能为空',
        trigger: ['blur']
      },
      {
        validator: validateContent,
        trigger: ['blur', 'change']
      }
    ]
  },
  {
    field: 'platform',
    defaultValue: 1,
    component: 'Radio',
    label: '短信平台',
    radioArr: [
      {
        label: '阿里云平台',
        value: 1
      },
      {
        label: '创蓝短信平台',
        value: 2
      },
      {
        label: '云浪无迹短信平台',
        value: 3
      }
    ]
  },
  {
    field: 'templateType',
    defaultValue: 1,
    component: 'Radio',
    label: '模板类型',
    radioArr: [
      {
        label: '短信验证码',
        value: 0
      },
      {
        label: '普通通知',
        value: 1
      },
      {
        label: '推广短信',
        value: 2
      }
    ]
  },
  {
    field: 'remark',
    defaultValue: '',
    component: 'InputTextArea',
    label: '模板申请说明',
    placeholder: '请输入备注, 短信模板申请说明，是模板审核的参考信息之一。。',
    rules: [
      {
        required: true,
        message: '备注不能为空',
        trigger: ['blur']
      }
    ]
  }
]

// 基础设置 form
export const yunFormSchemas = [
  {
    field: 'templateName',
    defaultValue: '',
    component: 'Input',
    label: '第三方平台模板名称',
    placeholder: '请输入第三方平台模板名称',
    rules: [
      {
        required: true,
        message: '第三方平台模板名称不能为空',
        trigger: ['blur']
      },
      {
        pattern: /^.{1,100}$/,
        message: '长度不超过100个字符',
        trigger: ['blur']
      }
    ]
  },
  {
    field: 'templateContent',
    defaultValue: '',
    component: 'InputTextArea',
    label: '审核通过的模板内容格式',
    placeholder: '请输入审核通过的模板内容格式,示例：您正在申请手机注册,验证码为：$' + '{code}.......',
    rules: [
      {
        required: true,
        message: '审核通过的模板内容格式不能为空',
        trigger: ['blur']
      },
      {
        validator: validateContent,
        trigger: ['blur', 'change']
      }
    ]
  },
  {
    field: 'platform',
    defaultValue: 1,
    component: 'Radio',
    label: '短信平台',
    radioArr: [
      {
        label: '阿里云平台',
        value: 1
      },
      {
        label: '创蓝短信平台',
        value: 2
      },
      {
        label: '云浪无迹短信平台',
        value: 3
      }
    ]
  },
  {
    field: 'templateType',
    defaultValue: 1,
    component: 'Radio',
    label: '模板类型',
    radioArr: [
      {
        label: '普通通知',
        value: 1
      }
    ]
  }
]

export const contentFormSchemas = [
  {
    field: 'templateName',
    defaultValue: '',
    component: 'Input',
    label: '第三方平台模板名称',
    placeholder: '请输入第三方平台模板名称',
    rules: [
      {
        required: true,
        message: '第三方平台模板名称不能为空',
        trigger: ['blur']
      },
      {
        pattern: /^.{1,100}$/,
        message: '长度不超过100个字符',
        trigger: ['blur']
      }
    ]
  },
  {
    field: 'paramsName',
    defaultValue: '',
    component: 'Input',
    label: '参数名称',
    disabled: true
  },
  {
    field: 'isParams',
    defaultValue: '',
    component: 'Input',
    label: '有无量参数',
    disabled: true
  },
  {
    field: 'templateContent',
    defaultValue: '',
    component: 'InputTextArea',
    label: '审核通过的模板内容格式',
    placeholder: '请输入审核通过的模板内容格式,示例：您正在申请手机注册,验证码为：$' + '{code}.......',
    rules: [
      {
        required: true,
        message: '审核通过的模板内容格式不能为空',
        trigger: ['blur']
      },
      {
        validator: validateContent,
        trigger: ['blur', 'change']
      }
    ]
  }
]
